import intl from "i18n/messages";
import { FormattedMessage as FM } from "react-intl";

/**
 *
 * @param {*} props -
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component TextField
 */

function CharCell(props) {
  const { field, layout, data } = props;
  let editedValue = data.value ?? "";
  const _value = `${layout.model}.${data.value}`;
  const isTranslated = data.value && field.translate;
  if (data.value && field.translate) {
    console.log("translated value:", _value);
    editedValue = intl.msgs[_value] || data.value;
  }

  // if (!field.editable) return editedValue;
  if (!field.editable) return isTranslated ? <FM id={_value} /> : editedValue;

  function onChange(event) {
    let _value = event.target.value;
    if (props.type === "integer") {
      _value = parseInt(_value);
    }
    editedValue = _value;
  }

  return (
    <div className="">
      <input
        key={props.name}
        id={props.name}
        name={props.name}
        className={
          "w-full py-2 px-2 text-gray-700 rounded-md bg-inherit focus:outline-none focus:border focus:border-cyan-500"
        }
        type={props.type || "text"}
        value={editedValue}
        onChange={onChange}
        readOnly={props.readOnly ?? false}
        placeholder={props.placeholder ?? ""}
      />
      {props.icon || null}
    </div>
  );
}

export default CharCell;
